var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { isEmpty, keyBy } from 'lodash';
import { SHERPATH_COURSE_TYPES } from 'constants/app.constant';
import { EvolveProductTypeKey } from 'constants/externalApp.constant';
import { DISTRIBUTION_OF_SCORES_RANGES } from 'reports/cw/constants/chart.constant';
import { COURSE_TYPE } from '../constants/cw.constant';
var fillExtendedOrangeClassName = 'u-els-fill-extended-orange-7';
var fillRemainingGreenClassName = 'u-els-fill-custom-extended-green-2';
export var coursePieChartConfig = Object.freeze({
    cx: 35,
    cy: 35,
    paddingAngle: 5,
    startAngle: 90,
    endAngle: -270
});
export var courseDistributionChartConfig = Object.freeze({
    barSize: 65,
    xAxisKey: 'name',
    yAxisKey: 'value',
    margin: { top: 5, right: 0, bottom: 0, left: 31 },
    shouldUseBorderLabel: true
});
export var sherpathCourseDistributionChartConfig = Object.freeze(__assign(__assign({}, courseDistributionChartConfig), { margin: { top: 5, right: 0, bottom: 5, left: 45 }, unit: '%', referenceLineLabels: [0, 50, 100] }));
var ChartDataId = {
    remaining: 'remaining',
    disengagedStudents: 'disengagedStudents',
    lateAssignmentStudents: 'lateAssignmentStudents',
    averageScore: 'averageScore'
};
export var courseTypeChartLabel = Object.values(COURSE_TYPE);
export var isSherpathClassicByCourseType = function (courseType) {
    return SHERPATH_COURSE_TYPES.some(function (appId) { return appId === courseType; });
};
export var isSherpathClassicCourse = function (course) {
    return !!(course === null || course === void 0 ? void 0 : course.sherpathCourse);
};
export var getCourseName = function (selectedCourseId, coursesInfo) {
    var _a;
    if (coursesInfo === void 0) { coursesInfo = []; }
    return ((_a = coursesInfo.find(function (course) { return course.id === selectedCourseId; })) === null || _a === void 0 ? void 0 : _a.courseName) || '';
};
export var getDisengagedStudentChartData = function (_a) {
    var disengagedStudents = _a.disengagedStudents, totalStudent = _a.totalStudent;
    return [
        { id: ChartDataId.disengagedStudents, value: disengagedStudents, colorClassName: fillExtendedOrangeClassName },
        { id: ChartDataId.remaining, value: totalStudent - disengagedStudents, colorClassName: fillRemainingGreenClassName }
    ];
};
export var geLateAssignmentStudentChartData = function (_a) {
    var numberOfStudentWithAnyIncompleteAssignment = _a.numberOfStudentWithAnyIncompleteAssignment, totalStudent = _a.totalStudent;
    return [
        { id: ChartDataId.lateAssignmentStudents, value: numberOfStudentWithAnyIncompleteAssignment, colorClassName: fillExtendedOrangeClassName },
        { id: ChartDataId.remaining, value: totalStudent - numberOfStudentWithAnyIncompleteAssignment, colorClassName: fillRemainingGreenClassName }
    ];
};
export var getAverageScoreChartData = function (_a) {
    var averageScore = _a.averageScore;
    return [
        { id: ChartDataId.averageScore, value: averageScore, colorClassName: fillExtendedOrangeClassName },
        { id: ChartDataId.remaining, value: 100 - averageScore, colorClassName: fillRemainingGreenClassName }
    ];
};
export var getScoreLabelByOverallScore = function (overallScore) {
    var percentOverallScore = overallScore * 100;
    var scoreRangeArray = Object.values(DISTRIBUTION_OF_SCORES_RANGES).map(function (value) { return ({ label: value.label, min: value.value.min, max: value.value.max }); });
    var foundRange = scoreRangeArray.find(function (range) { return range.min <= percentOverallScore && range.max >= percentOverallScore; }) || { label: '' };
    return foundRange.label;
};
export var getDistributionOfScoreChartData = function (studentOverallScores) {
    var _a;
    var FROM_0_TO_54 = DISTRIBUTION_OF_SCORES_RANGES.FROM_0_TO_54, FROM_55_TO_64 = DISTRIBUTION_OF_SCORES_RANGES.FROM_55_TO_64, FROM_65_TO_74 = DISTRIBUTION_OF_SCORES_RANGES.FROM_65_TO_74, FROM_75_TO_84 = DISTRIBUTION_OF_SCORES_RANGES.FROM_75_TO_84, FROM_85_TO_100 = DISTRIBUTION_OF_SCORES_RANGES.FROM_85_TO_100;
    var numberOfStudentHaveScore = (_a = {},
        _a[FROM_0_TO_54.label] = 0,
        _a[FROM_55_TO_64.label] = 0,
        _a[FROM_65_TO_74.label] = 0,
        _a[FROM_75_TO_84.label] = 0,
        _a[FROM_85_TO_100.label] = 0,
        _a);
    studentOverallScores.forEach(function (_a) {
        var _b = _a.overallScore, overallScore = _b === void 0 ? 0 : _b;
        var scoreLabel = getScoreLabelByOverallScore(overallScore);
        if (!isEmpty(scoreLabel)) {
            numberOfStudentHaveScore[scoreLabel] += 1;
        }
    });
    return [
        {
            name: DISTRIBUTION_OF_SCORES_RANGES.FROM_0_TO_54.label,
            value: numberOfStudentHaveScore[FROM_0_TO_54.label],
            fillColorClassName: 'u-els-fill-custom-old-brick'
        },
        {
            name: DISTRIBUTION_OF_SCORES_RANGES.FROM_55_TO_64.label,
            value: numberOfStudentHaveScore[FROM_55_TO_64.label],
            fillColorClassName: 'u-els-fill-custom-orange-2'
        },
        {
            name: DISTRIBUTION_OF_SCORES_RANGES.FROM_65_TO_74.label,
            value: numberOfStudentHaveScore[FROM_65_TO_74.label],
            fillColorClassName: 'u-els-fill-custom-bright-sun'
        },
        {
            name: DISTRIBUTION_OF_SCORES_RANGES.FROM_75_TO_84.label,
            value: numberOfStudentHaveScore[FROM_75_TO_84.label],
            fillColorClassName: 'u-els-fill-custom-green-2'
        },
        {
            name: DISTRIBUTION_OF_SCORES_RANGES.FROM_85_TO_100.label,
            value: numberOfStudentHaveScore[FROM_85_TO_100.label],
            fillColorClassName: 'u-els-fill-chart-green-3'
        }
    ];
};
export var getDistributionOfAverageScoreByTypeChartData = function (averageScoresByTypes) {
    var sortedAverageScoresByTypes = __spreadArray([], averageScoresByTypes, true).sort(function (a, b) { return b.averageScore - a.averageScore; });
    var topAverageScoresByTypes = sortedAverageScoresByTypes.slice(0, 3);
    return topAverageScoresByTypes.map(function (score) { return ({
        name: (courseTypeChartLabel.find(function (label) { return score.assignmentType.toLowerCase() === label.value.toLowerCase(); }) || { display: '' }).display,
        value: score.averageScore,
        fillColorClassName: 'u-els-fill-info'
    }); });
};
export var getCourseSectionIsbns = function (courseSection) {
    var entitlements = courseSection.entitlements
        .map(function (entitlement) {
        if (!entitlement || !entitlement.data) {
            return {
                entitlement: entitlement,
                evolveProduct: null
            };
        }
        return {
            entitlement: entitlement,
            evolveProduct: JSON.parse(entitlement === null || entitlement === void 0 ? void 0 : entitlement.data)
        };
    })
        .filter(function (item) {
        return item.evolveProduct;
    });
    var filteredEntitlements = entitlements.filter(function (entitlement) {
        if (!entitlement.evolveProduct) {
            return false;
        }
        return [
            EvolveProductTypeKey.SHERPATH_IA,
            EvolveProductTypeKey.SHERPATH_BOOK_ORGANIZED,
            EvolveProductTypeKey.SHADOW_HEALTH,
            EvolveProductTypeKey.EAQNG_IA,
            EvolveProductTypeKey.SIMULATION_SIM_CHART_NG,
            EvolveProductTypeKey.HESI_CASE_STUDY,
            EvolveProductTypeKey.HESI_PATIENT_REVIEW,
            EvolveProductTypeKey.HESI_PRACTICE_TEST,
            EvolveProductTypeKey.NURSING_CONCEPTS_IA
        ].includes(entitlement.evolveProduct.productTypeKey);
    });
    return filteredEntitlements.map(function (entitlement) { return entitlement.entitlement.isbn.toString(); });
};
export var buildCourseData = function (courses, courseSections) {
    var courseSectionMap = keyBy(courseSections, 'id');
    return (courses || []).map(function (course) {
        var _a;
        return (__assign(__assign({}, course), { courseName: ((_a = courseSectionMap[course.courseSectionId]) === null || _a === void 0 ? void 0 : _a.courseName) || '' }));
    });
};
